import ApiService from './ApiService'
import { Config } from '../core/config';

const getFlow = (body) => {
    return ApiService.post(`${Config.apiPaywall}/Paywall/GetFlow`, body);
};

export default {
    getFlow
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/services/flow.js